module.exports = __webpack_public_path__ + "static/media/apartment18.8951ac67.jpg";